<template>
  <!-- 测试页面 -->
  <section class="container">
    <Header @loadPage="onload"></Header>
    <div class="wrapper TestM">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt />
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem to="/Exam">测试</BreadcrumbItem>
          <BreadcrumbItem>题目</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="innerM">
        <div class="title flex-row">
          <div class="col-70">{{exercisetitle}}</div>
          <div class="col-30 flex-row relative">
            <div class="col-30"></div>
            <div class="text-right col-35 amount">{{answered}} / {{length}}</div>
            <div class="text-right col-35">
              <Button class="btn" type="primary" size="large" @click="modal3 = true">交卷</Button>
            </div>
            <div class="All" :class="$store.state.fixed ? 'fixed' : ''">
              <div
                class="col-10 text-center"
                v-for="(answer, index) in answerData"
                :class="[ (answer.userAnswer != '' || answer.userAnswers != '')  ? 'answerBlue':'']"
              >
                <a :href="'#anchor'+ index">{{index + 1}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="inner-wrapper text-left">
          <div class="single" v-for="(questionlist, index) in dataList">
            <div
              class="title2"
            >{{questionlist.exerciseBlockId}}、{{questionlist.title}}。（共{{questionlist.totalNumber}}题，合计{{questionlist.totalScore}}分）</div>
            <div
              class="subject"
              v-for="(question, index1) in questionlist.questionList"
              :key="index1"
            >
              <div class="question">
                <a :id="'anchor'+question.topicId" class="anchor"></a>
                [{{questionlist.title}}]&nbsp;{{question.questionTitle}}（{{question.score}}分）
              </div>
              <!--单选题-->
              <RadioGroup
                v-model="answerList[index][index1].userAnswer"
                v-if="questionlist.questionType == 1"
              >
                <div
                  class="options"
                  v-for="(option, index2) in question.questionOptionList"
                  :key="index2"
                >
                  <Radio :label="option.optionId">
                    <span>{{option.title}}</span>
                  </Radio>
                </div>
              </RadioGroup>
              <!--多选题-->
              <CheckboxGroup
                v-model="answerList[index][index1].userAnswers"
                v-if="questionlist.questionType == 2"
              >
                <div
                  class="options"
                  v-for="(option, index2) in question.questionOptionList"
                  :key="index2"
                >
                  <Checkbox :label="option.optionId">
                    <span>{{option.title}}</span>
                  </Checkbox>
                </div>
              </CheckboxGroup>
              <!--单判断题-->
              <RadioGroup
                v-model="answerList[index][index1].userAnswer"
                v-if="questionlist.questionType == 3"
              >
                <div class="options">
                  <Radio label="1">
                    <span>对</span>
                  </Radio>
                </div>
                <div class="options">
                  <Radio label="0">
                    <span>错</span>
                  </Radio>
                </div>
              </RadioGroup>
            </div>
          </div>
        </div>
        <div class="submit">
          <Button type="primary" size="large" @click="modal3 = true">提交试卷</Button>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Modal v-model="modal3" @on-ok="sendAnswer" @on-cancel="cancel">
      <h2 style="padding: 25px 0;" class="text-center">是否确定提交试卷？</h2>
    </Modal>
    <el-dialog title="考试结果" :visible.sync="resultDialog" width="460px">
      <div class="resultlist">
        <div class="result">
          <p>{{result.notAnswerNumber}}</p>
          <p>未答题数</p>
        </div>
        <div class="result">
          <p>{{result.score}}</p>
          <p>考试得分</p>
        </div>
        <div class="result">
          <p>{{result.errorAnswerNumber}}</p>
          <p>错题数</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="problemViwe">前往错题库</el-button>
        <el-button type="success" @click="resultDialog = false">确 认</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "Test",
  data() {
    return {
      modal3: false,
      exercisetitle: "", //试卷名称
      exerciseId: "", //试卷id
      dataList: [], //接口初始数据
      answerList: [], //配合题目的答案列表
      answered: 0, //已答题数
      answerData: [], //接口需要的答案列表
      length: 0, //总题数
      result: {}, //考试结果
      resultDialog: false
    };
  },
  mounted() {
    this.onload();
    this.setTab();
  },
  watch: {
    answerList: {
      handler(newValue, oldValue) {
        var that = this;
        var tmp = [];
        for (var i = 0; i < newValue.length; i++) {
          tmp = tmp.concat(newValue[i]);
        }
        that.answerData = tmp;
      },
      deep: true
    },
    answerData: {
      handler(newValue, oldValue) {
        var that = this;
        var count = 0;
        for (var i = 0; i < newValue.length; i++) {
          var tmp = newValue[i];
          if (tmp.userAnswer != "" || tmp.userAnswers != "") {
            count += 1;
          }
        }
        that.answered = count;
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    onload() {
      //初始化
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      var username = that.$cookie.get("xjaf-user");
      if (token != null && username != null) {
        this.httprequest();
        //恢复滚动
        $("body").removeAttr("style");
      } else {
        this.$store.commit("login");
      }
    },
    httprequest() {
      var that = this;
      var modelData = {};
      this.$http({
        url:
          that.webhost +
          "exercise/getPaperFromWeb/" +
          that.$route.params.exerciseId,
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var tmp = data.data.blockList;
          for (var i = 0; i < tmp.length; i++) {
            switch (i) {
              case 0:
                tmp[i].exerciseBlockId = "一";
                break;
              case 1:
                tmp[i].exerciseBlockId = "二";
                break;
              case 2:
                tmp[i].exerciseBlockId = "三";
                break;
              case 3:
                tmp[i].exerciseBlockId = "四";
                break;
              case 4:
                tmp[i].exerciseBlockId = "五";
                break;
              case 5:
                tmp[i].exerciseBlockId = "六";
                break;
            }
          }
          that.dataList = that.loadanswered(tmp);
          that.exercisetitle = data.data.title;
          that.exerciseId = data.data.exerciseId;
          var length = 0;
          for (var i = 0; i < that.dataList.length; i++) {
            length += that.dataList[i].totalNumber;
          }
          that.length = length;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    loadanswered(dataList) {
      //  初始化答案数组--和题目序号初始化
      var that = this;
      var topicId = 0;
      var tmp = [];
      for (var i = 0; i < dataList.length; i++) {
        tmp[i] = [];
        for (var j = 0; j < dataList[i].questionList.length; j++) {
          dataList[i].questionList[j].topicId = topicId;
          topicId++;
          var answeredTmp = {
            exerciseQuestionId: dataList[i].questionList[j].exerciseQuestionId, //题目id
            userAnswer: "", //单选和判断答案 选项id
            userAnswers: [] //多选题答案 选项id
          };
          tmp[i].push(answeredTmp);
        }
      }
      that.answerList = tmp;
      return dataList;
    },
    problemViwe() {
      var that = this;
      this.$router.push("/ProblemLibrary/" + that.exerciseId);
    },
    sendAnswer() {
      var that = this;
      var modelData = {
        answerList: this.answerData,
        exerciseId: this.exerciseId
      };
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "Loading")
          ]);
        }
      });
      this.$http({
        url: that.webhost + "exercise/submitAnswer",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        this.$Spin.hide();
        console.log(data);
        if (data && data.code === 0) {
          that.$Message.success("交卷成功！");
          that.result = data.data;
          that.resultDialog = true;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    cancel() {
      this.modal3 = false;
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped>
.anchor {
  position: absolute;
  top: -65px;
}
.anchor a {
  color: #ffffff;
}
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}
.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
}
.locationM {
  height: 50px;
  line-height: 50px;
}
.locationM .ivu-breadcrumb {
  font-size: 15px;
  color: #000;
}
.locationM img {
  width: 23px;
  height: 22px;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.btn {
  width: 100px;
  background: #23b8ff;
  border-color: #23b8ff;
}
.amount {
  font-size: 19px;
  position: relative;
  top: 4px;
}
.inner-wrapper {
  width: 930px;
  padding: 20px;
}
.title2 {
  font-size: 19px;
  color: #000;
}
.subject {
  padding: 15px 0;
}
.question {
  position: relative;
  color: #333;
  font-size: 17px;
  line-height: 35px;
}
.options span {
  font-size: 16px;
  line-height: 30px;
  position: relative;
  top: 2px;
  padding-left: 10px;
}
.double,
.judge {
  margin-top: 20px;
}
.submit {
  margin-top: 50px;
}
.submit button {
  width: 140px;
  background: #23b8ff;
  font-size: 17px;
  border-color: #23b8ff;
}
.title .All {
  position: absolute;
  top: 90px;
  right: 10px;
  z-index: 999;
  width: 250px;
  min-height: 170px;
  padding: 5px;
  color: #fff;
  line-height: 30px;

  background: #87ceff;
  height: 500px;
  box-shadow: 0 1px 10px 3px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
  overflow-y: auto;
}
.title .All::-webkit-scrollbar-thumb {
  background: #f5f5f5;
}
.title .All::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: #87ceff;
}
.title .All::-webkit-scrollbar {
  /* width: 10px;
  height: 10px; */
  width: 5px;
  height: 5px;
  border-left: 1px solid #2659a7;
}
.title .fixed {
  position: fixed;
}
.All .col-10 {
  display: inline-block;
  /*height: 15px;*/
  font-size: 13px;
}
.answerBlue {
  color: #000;
}
.answerBlue a {
  color: #000 !important;
}
.resultlist {
  width: 360px;
  margin: auto;
  overflow: hidden;
}
.result {
  font-size: 20px;
  width: 120px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Test.vue